import React from 'react'
import { Volume2 } from 'lucide-react'
import store from '../state/store'

class VolumeSlider extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      volume: this.props.volume,
      soundOption: this.props.soundOption
    }
  }

  onAdjustVolume = (e) => {
    let volume = e.currentTarget.value
    store.emit('media:sound:volume', volume)
    store.emit('media:sound:play')
    this.setState({
      volume: volume
    })
  }

  onSoundChange = (e) => {
    let soundOption = e.currentTarget.value
    store.emit('media:sound:update', soundOption)
    store.emit('media:sound:play')
    this.setState({
      soundOption: soundOption
    })
  }

  render() {
    const sounds = [
      ['ping.wav', 'Ping'],
      ['laser.mp3', 'Laser'],
      ['whistle.mp3', 'Whistle'],
      ['lion.mp3', 'Lion']
    ]

    return(
      <div>
        <div className="flex items-center gap-2"><Volume2 className="size-4"/>Ping volume</div>
        <input type="range" min="0" max="1" step='0.1' value={this.state.volume} id="volume-control" onChange={this.onAdjustVolume}/>
        {sounds.map(([value, name]) => (
          <label key={value} className="flex cursor-pointer items-center gap-2 font-normal">
            <input type="radio" name="soundOption" value={value} onChange={this.onSoundChange} checked={this.state.soundOption === value}/>
            {name}
          </label>
        ))}
      </div>
    )
  }
}

export default VolumeSlider
